import { render, staticRenderFns } from "./noFollow.vue?vue&type=template&id=240413af&scoped=true"
import script from "./noFollow.vue?vue&type=script&lang=js"
export * from "./noFollow.vue?vue&type=script&lang=js"
import style0 from "./noFollow.vue?vue&type=style&index=0&id=240413af&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240413af",
  null
  
)

export default component.exports